import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Dropdown, Spinner } from '@factorialco/f0-react/dist/experimental'

import { useSyncRunSyncing } from 'modules/integrations/hooks/useSyncRunSyncing'

export const Syncing = () => {
  const { isLoading, syncingLabel, syncingCounter, dropdownItems } = useSyncRunSyncing()

  if (isLoading) {
    return (
      <Box flexDirection="row" gap="s8" alignItems="center" padding="s8">
        <Spinner size="small" />
        <Text.Normal size="200">{syncingLabel}</Text.Normal>
      </Box>
    )
  }

  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      <Dropdown items={dropdownItems}>
        <F0Button variant="ghost" icon={Spinner} label={`${syncingLabel} ${syncingCounter}`} />
      </Dropdown>
    </Box>
  )
}
